import React from 'react';
import { getGamePriceDisplay, getBundlePriceDisplay } from '../utils/gamePrice';

function GamePrice({ game, bundle, isOwned = false, size = 'md', hideDiscount = false }) {
  const price = bundle ? getBundlePriceDisplay(bundle) : getGamePriceDisplay(game, isOwned);
  const showStrikethrough = price.strikethrough && !hideDiscount;

  const textClass =
    size === 'sm'
      ? 'text-xs font-semibold'
      : size === 'lg'
        ? 'text-2xl lg:text-3xl font-bold'
        : 'text-base font-semibold';

  const oldPriceClass =
    size === 'sm' ? 'text-[11px]' : size === 'lg' ? 'text-sm lg:text-base' : 'text-sm';

  const shardIconClass =
    size === 'sm' ? 'h-3' : size === 'lg' ? 'h-6 lg:h-7' : 'h-5';

  if (price.type === 'shards') {
    return (
      <div className="flex items-center gap-2">
        <img src="/images/shard_white.png" alt="Shard" className={`${shardIconClass} w-auto opacity-80`} />
        <span className={`${textClass} text-white`}>{price.label}</span>
      </div>
    );
  }

  if (showStrikethrough) {
    return (
      <div className="flex items-baseline gap-2">
        <span className={`${textClass} text-white tabular-nums`}>{price.label}</span>
        <span className={`${oldPriceClass} text-white/40 line-through tabular-nums`}>
          {price.strikethrough}
        </span>
      </div>
    );
  }

  return (
    <span className={`${textClass} text-white tabular-nums`}>{price.label}</span>
  );
}

export default GamePrice;
